import routePush from './routePush';
import { cookiesConstants, getCookie } from './cookies';
var servicesRedirect = function servicesRedirect() {
  var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
    _ref$type = _ref.type,
    type = _ref$type === void 0 ? 'default' : _ref$type,
    cartUrl = _ref.cartUrl,
    categoryId = _ref.categoryId,
    subCategoryId = _ref.subCategoryId;
  var TOGGLE_NEW_SERVICE_PAGE_SPA = cookiesConstants.TOGGLE_NEW_SERVICE_PAGE_SPA;
  var cookieValue = getCookie(TOGGLE_NEW_SERVICE_PAGE_SPA);
  var toggleNewServicePageSpa = cookieValue ? cookieValue === 'true' : true;
  var urlParams = new URLSearchParams();
  urlParams.set('typeButton', type);
  if (categoryId) {
    urlParams.set('categoryId', categoryId);
  }
  if (subCategoryId) {
    urlParams.set('subCategoryId', subCategoryId);
  }
  return routePush({
    path: "".concat(cartUrl == null ? void 0 : cartUrl.guarantee, "?").concat(urlParams.toString()),
    spa: toggleNewServicePageSpa
  });
};
export default servicesRedirect;